import type { User, UserManager } from "oidc-client-ts";

/**
 * Returns the signed-in user, attempting {@link UserManager.signinSilent} if the
 * stored access token is already expired (e.g. tab left open past TTL).
 */
export async function getActiveUser(mgr: UserManager): Promise<User | null> {
  let user = await mgr.getUser();
  if (!user) return null;
  if (user.expired) {
    try {
      const renewed = await mgr.signinSilent();
      return renewed ?? null;
    } catch {
      return null;
    }
  }
  return user;
}
